module.exports = __webpack_public_path__ + "static/img/Order_Buy@3x.d47638c5.png";